import merge from 'lodash/merge.js';

import BaseSections from '@/store/modules/base/BaseSections.js';

export default merge(BaseSections({ formType: 'CourseTemplateForm', name: 'SectionTemplates' }), {});
